import { GisDatenVWG } from '@ps20-frontend/frontend-models';
import { IAppState } from '../../../store/appState';

export const selectGisFlutzone = (state: IAppState): number => state.gisDaten?.flutzone;

export const selectGisDaten = (state: IAppState): GisDatenVWG => state?.gisDaten;
